<template>
  <div>
    <v-dialog v-model="dialog" width="413" scrollable>
      <v-card id="locationEdit">
        <v-card-title v-if="modalMode === 'create'" class="secondary">{{$t('add-location')}}</v-card-title>
        <v-card-title v-if="modalMode === 'edit'" class="secondary">{{$t('edit-location')}}</v-card-title>
        <v-card-text>
          <v-form @submit.stop.prevent id="locationEditForm">
            <v-row justify="center">
              <v-col cols="11">
                <!-- name -->
                <v-text-field
                  :label="$t('name')"
                  tabindex="1"
                  :dense="true"
                  v-model="form.name"
                  outlined
                  :error-messages="nameErrors"
                  @input="$v.form.name.$touch()"
                  @blur="$v.form.name.$touch()"
                  color="secondary"
                ></v-text-field>
                <!-- mac address -->
                <v-text-field
                  :label="$t('devices-page-device-mac-address')"
                  tabindex="2"
                  v-model="form.macAddress"
                  @keyup="formatMacAddress"
                  :dense="true"
                  :error-messages="macAddressErrors"
                  :disabled="modalMode === 'edit'"
                  outlined
                  required
                  color="secondary"
                  @change="$v.form.macAddress.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col cols="12">
            <v-btn
              v-if="modalMode === 'edit'"
              depressed
              color="secondary"
              tabindex="3"
              @click="editLocationFn"
              class="px-8 float-right"
            >{{$t('save')}}</v-btn>
            <v-btn
              v-if="modalMode === 'create'"
              depressed
              color="secondary"
              tabindex="3"
              @click="createLocationFn"
              class="px-8 float-right"
            >{{$t('add')}}</v-btn>
             <v-btn
              text
              color="secondary"
              tabindex="3"
              @click="resetForm"
              class="px-8 mr-2 float-right"
            >{{$t('cancel')}}</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { macAddressValidator } from '../../mixins/macAddressValidator';

export default {
  data() {
    return {
      dialog: false,
      currentLocation: null,
      form: {
        name: '',
        macAddress: ''
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required
      },
      macAddress: {
        required,
        minLength: minLength(27),
      },
    },
  },
  props: ['modalMode', 'area'],
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required &&
        errors.push(this.$t('error-name-required'));
      return errors;
    },
    macAddressErrors() {  
    const errors = [];
    if (!this.$v.form.macAddress.$dirty) return errors;
    !this.$v.form.macAddress.required &&
      errors.push(this.$t('devices-error-mac-address-required'));
    !this.$v.form.macAddress.minLength &&
      errors.push(this.$t('devices-error-mac-address-min-length'));
    return errors;
  },
  },
  methods: {
    ...mapActions('location', ['createLocation','editLocation',]),
    openModal(location) {      
      this.dialog = true;
      if (location) {
        this.currentLocation = location;
        Object.assign(this.form, {
        name: location.name,
        macAddress: macAddressValidator.computed.formatMacAddress(
            location.macAddress
          ),
      });
      } else {
      Object.assign(this.form, {
        name: '', 
        macAddress: ''
      });
      }
    },
    resetForm() {
      this.$v.form.$reset();
      Object.assign(this.form, {
        name: '',
      });
      this.dialog = false;
    },
    formatMacAddress() {
      this.$set(
        this.form,
        'macAddress',
        macAddressValidator.computed.formatMacAddress(this.form.macAddress)
      );
    },
    async editLocationFn() {
      this.$v.$touch();
      if (!this.$v.form.$anyError && this.modalMode === 'edit' && this.currentLocation) {
        const location = {
          name: this.form.name,
          siteId: this.area?.site?.id || this.currentLocation.siteId,
        };
        const locationId = this.currentLocation.id;
        try {
          let resp = await this.editLocation({locationId, location})
          this.$toasted.show(this.$t('location-edited'), {
              position: 'bottom-right',
              className: ['toast-success'],
              duration: 2000,
            });
            this.$emit('changeOnLocations', this.currentLocation);
            this.resetForm();
        } catch (error) {
            this.$toasted.show(error, {
              position: 'bottom-right',
              className: ['toast-error'],
              duration: 5000,
            });
        }
      }
    },
    async createLocationFn() {
      this.$v.$touch();
      if (!this.$v.form.$anyError && this.modalMode === 'create') {
        const location = {
          name: this.form.name,
          macAddress: this.form.macAddress.replace(/\s/g, ''),
          siteId: this.area.site.id,
        };
        try {
          const resp = await this.createLocation( location )
            this.$toasted.show(this.$t('location-created'), {
              position: 'bottom-right',
              className: ['toast-success'],
              duration: 2000,
            });
            this.$emit('changeOnLocations');
            this.resetForm();
        } catch (error) {
          this.$toasted.show(error, {
              position: 'bottom-right',
              className: ['toast-error'],
              duration: 5000,
            });
        }
      }
    },
  },
};
</script>
<style scoped>
#locationEditForm {
  padding-top: 2rem;
}
</style>